// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const eid: CountryValidator<"AE"> = createValidator(
  "ae.eid",
  1,
);

export default eid;
export const compact = eid.compact;
export const format = eid.format;
export const validate = eid.validate;
export const generate = (): string =>
  eid.generate?.() ??
  (() => {
    throw new Error(
      "Validator ae.eid cannot generate values",
    );
  })();
